import { ButtonLink, ButtonSize } from '@farmasiet/frontendcore-reactcomponents';
import * as React from 'react';

import { getTranslation, keys } from '../../../../../Resources/Translations';
import { PriceDisplay } from '../../../../ReactComponents/PriceDisplay';
import { CartShippingInfoViewModel } from '../../ViewModels/CartShippingInfo/CartShippingInfoViewModel.csharp';

interface CartSummaryFooterProps {
    hasErrors: boolean;
    cartSummaryUrl: string;
    subTotalWithDiscounts: number;
    shippingInfo: CartShippingInfoViewModel;
    hasRxItems: boolean;
}

export const CartSummaryFooter = (props: CartSummaryFooterProps) => {
    const [buttonClicked, setButtonClicked] = React.useState(false);
    const shippingCost = props.shippingInfo && props.shippingInfo.cheapestMethodInfo && props.shippingInfo.cheapestMethodInfo.shippingCost;

    return (
        <div className="CartSummary__Footer">
            {!!shippingCost && shippingCost > 0 && !props.hasRxItems && (
                <div className="CartSummary__Delivery">
                    <span className="CartSummary__FooterLabel">
                        <span className={'CartSummary__FooterLabel--Uppercase'}>{getTranslation(keys['cartSummary.delivery'])}</span>
                    </span>
                    <span>
                        {getTranslation(keys['cartSummary.from'])} <PriceDisplay price={shippingCost} />
                    </span>
                </div>
            )}
            <div className="CartSummary__TotalSum">
                <span className="CartSummary__FooterLabel">
                    <span tabIndex={0}>{getTranslation(keys['cartSummary.totalSum'])}</span>
                    <span className="CartSummary__AdditionalInfo">{getTranslation(keys['cartSummary.includingTaxes'])}</span>
                </span>
                <span className="CartSummary__TotalPrice" tabIndex={0}>
                    {' '}
                    <PriceDisplay price={props.subTotalWithDiscounts} showCurrency={true} />
                </span>
            </div>

            <ButtonLink size={ButtonSize.Large} href={props.cartSummaryUrl} disabled={buttonClicked} onClick={() => !props.hasErrors && setButtonClicked(true)}>
                {getTranslation(keys['cartSummary.goToCart'])}
            </ButtonLink>
        </div>
    );
};
